import React from 'react'
import NavBarProfile from './NavBarProfile'
import SideBar from './SideBar'
import { Box, Grid, Typography } from '@mui/material'
import Menu from './Menu'
import Home from './Home'
import { Route, Routes } from 'react-router'
import FormInfoPersonalPage from './FormInfoPersonalPage'
import FormInfoHousePage from './FormInfoHousePage'
import FormStateDesc from './FormStateDesc'
import FormDocuments from './FormDocuments'
import FormTerms from './FormTerms'
import Navbar from '../Auth/Navbar'

function LayoutProfile() {
    return (
        <>
        <Navbar />
            <Grid container sx={{ backgroundColor: "#fff" }}>

                <Grid item xs={1}>
                    <Menu />
                </Grid>
                <Grid item xs={8}>
                    <NavBarProfile />
                    <Routes>
                        
                        <Route path='/' element={<Home />} />
                        <Route path='/InputInfoPersonal' element={<FormInfoPersonalPage />} />
                        <Route path='/InputInfoHouse' element={<FormInfoHousePage />} />
                        <Route path='/InputInfoDesc' element={<FormStateDesc />} />
                        <Route path='/InputDocuments' element={<FormDocuments />} />
                        <Route path='/InputTerms' element={<FormTerms />} />
                    </Routes>
                </Grid>
                <Grid item xs={2}>
                    <SideBar />
                </Grid>

            </Grid>
            <Box sx={{ width: "100%", textAlign: "center", pt: 2 }}>
                <Typography>
                    جميع الحقوق محفوظة لصالح فريق نبني 2025
                </Typography>

            </Box>

        </>
    )
}

export default LayoutProfile